import { render } from "./PRPMicroneedlingFacialContentPtBR.vue?vue&type=template&id=059aa4cd"
import script from "./PRPMicroneedlingFacialContentPtBR.vue?vue&type=script&lang=js"
export * from "./PRPMicroneedlingFacialContentPtBR.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__